<h2 mat-dialog-title>Service Request Notification Preview</h2>

<mat-dialog-content>
    <mat-card appearance="outlined">
        <mat-card-content>
            <div>{{subject}}</div>
            <br>
            <br>
            <div>{{message}}</div>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
    <command-bar [commands]="commands"></command-bar>
</mat-dialog-actions>